import React from "react";
import { useRef } from "react";
import { useEffect } from "react";
import ShareButton from "./share-button";
import FontSizeButton from "./font-size"
import BookmarkButton from "./bookmark-button";
import EditPostButton from "./edit-post-button"

import styled from 'styled-components'


const AnimatedDiv = styled.div`
  transition: top 0.3s ease 0s;
`;


export function DesktopFollowingPanel ({
  title, uri,
  image, author,
  video, is_media,
  zero_ref_element_query_elector,
  top_ref_element_query_elector,
  bottom_ref_element_query_elector,
  postId, vertical, kind, from404
}) {

  const thisComponentRef = useRef();

  useEffect(
    () => {
      window.addEventListener('scroll', handleScroll);

      return () => {
        window.removeEventListener('scroll', handleScroll);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );


  function handleScroll() {

    let top_ref_element = document.querySelector(top_ref_element_query_elector);
    let bottom_ref_element = document.querySelector(bottom_ref_element_query_elector);

    let zero_ref_element;
    if (zero_ref_element_query_elector) {
      zero_ref_element = document.querySelector(zero_ref_element_query_elector);
    }

    try {
      let upper_limit = Math.round(top_ref_element.getBoundingClientRect().y + window.pageYOffset);
      let bottom_limit = Math.round(bottom_ref_element.getBoundingClientRect().bottom + window.pageYOffset);
      let _thisCompRect = thisComponentRef.current.getBoundingClientRect();
      let _thisCompFCRect = thisComponentRef.current.firstChild.children[2].firstChild.getBoundingClientRect();
      // console.log('-----------------------------------');
      // let folComp_y = Math.round(_thisCompFCRect.y + window.pageYOffset);
      let contFolComp_y = Math.round(_thisCompRect.y + window.pageYOffset);
      let folComp_h = Math.round(_thisCompFCRect.height);
      // console.log(folComp_h, _thisCompRect, _thisCompFCRect);
      // debugger
      // bottom_limit = Math.round(bottom_limit - folComp_h);
      // let folComp_bottom = Math.round(_thisCompFCRect.bottom + window.pageYOffset);

      let scroll_adjust = 0;
      let scroll_y = Math.round(window.pageYOffset);
      let new_top;
      if (zero_ref_element) {
        if (window.pageYOffset > (zero_ref_element.getBoundingClientRect().y + window.pageYOffset)) {
          scroll_adjust = Math.round(zero_ref_element.getBoundingClientRect().y + window.pageYOffset);
          new_top = scroll_y - scroll_adjust;
        } else {
          new_top = 0;
        }
      } else {
        new_top = scroll_y;
      }

      if ((contFolComp_y + new_top + folComp_h) > bottom_limit) {
        new_top = Math.round(
          bottom_limit - contFolComp_y - folComp_h
        );
      } else if ((contFolComp_y + new_top) < upper_limit) {
        new_top = (upper_limit > contFolComp_y) ? (upper_limit - contFolComp_y) : 0;
      }

      thisComponentRef.current.firstChild.style.top = new_top + 'px';

    } catch (error) {
      console.error(error);
      // debugger;
    }
  }

  return (
    <div
      className="show_desktop share-desktop-panel-container desktop-following-panel-comp"
      style={{ position: "relative", height: "0" }}
      ref={thisComponentRef}
    >
      <AnimatedDiv
        style={{
          position: "absolute",
          width: "100%",
          display: "flex",
          height: "0",
        }}
      >
        <div style={{ flex: 1 }}></div>
        <div
          className="share-desktop-centered-div"
          style={{ width: "680px", height: '0' }}
        ></div>
        <div style={{ flex: 1 }}>
          <div style={{ paddingLeft: "24px" }}>
            <div style={{ marginBottom: "0.5rem" }}>
              <EditPostButton postId={postId} vertical={vertical} kind={kind} />
            </div>
            {
              from404 ?
              '' :
              <div>
                <ShareButton title={title} uri={uri} />
              </div>
            }
            <div>
              <FontSizeButton />
            </div>
            <div>
              <BookmarkButton
                news_url={uri}
                // news_title={title}
                // news_image={image}
                // news_author={author}
                // news_video={video}
                // news_is_media={is_media}
                // components_name_md5={uri}
                // news_category={category ? category : undefined}
                // news_excerpt={excerpt ? excerpt : undefined}
                // news_date={date ? date : undefined}
              />
            </div>
            {/* <div style={{display: "none"}}>
            {zero_ref_element_query_elector}
          </div>
          <div style={{display: "none"}}>
            {top_ref_element_query_elector}
          </div>
          <div style={{display: "none"}}>
            {bottom_ref_element_query_elector}
          </div> */}
          </div>
        </div>
      </AnimatedDiv>
    </div>
  );
}
